import React, { FC } from 'react'
import { Maybe, PageGiveawayTabsItem } from '@/types/codegen-contentful'
import { useGiveawayContext } from '../../context/GiveawayContext'
import { PresaleDetailsTab } from './PresaleDetailsTab/PresaleDetailsTab'
import { PresalesFAQsTab } from './PresaleFAQsTab'
import { PrizeItemsTab } from './PrizeItemsTab'

interface TabContentProps {
  tab: Maybe<PageGiveawayTabsItem>
}

export const TabContent: FC<TabContentProps> = ({ tab }) => {
  const { content } = useGiveawayContext()
  if (!tab) return null

  switch (tab.__typename) {
    case 'GiveawayDetailsTab':
      return (
        <PresaleDetailsTab
          trailerId={content.youtubeTrailerId}
          galleryImages={tab?.galleryImagesCollection?.items}
          videoThumbnail={tab?.videoThumbnail}
          text={tab?.text}
        />
      )

    case 'GiveawayPrizesTab':
      return <PrizeItemsTab content={tab} />

    case 'GiveawayFaqTab':
      return <PresalesFAQsTab content={tab} />

    default:
      return null
  }
}
